import Vue from 'vue'

export const obserState = Vue.observable({
    currentMachine: 0, 
    simulator: 0,
    inProgressIs: 0, // 1 locl 2 server 3 robot install 4 robot play
    stopOr: false,
    buttonLock: false,
})

export function update ({ key, val }) {
    obserState[key] = val
}

export const obserMutations = {
    update
}
